var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCopyFill = function SvgCopyFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18q-.825 0-1.412-.587A1.93 1.93 0 0 1 7 16V4q0-.824.588-1.412A1.93 1.93 0 0 1 9 2h9q.824 0 1.413.587Q20 3.176 20 4v12q0 .824-.587 1.413A1.93 1.93 0 0 1 18 18zm-4 4q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 20V7q0-.424.288-.713A.97.97 0 0 1 4 6q.424 0 .713.287Q5 6.576 5 7v13h10q.424 0 .713.288.287.287.287.712 0 .424-.287.712A.97.97 0 0 1 15 22z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCopyFill);
export { ForwardRef as ReactComponent };